<!--
 * @Description:流程页-流程组件
 * @Author: ningjz
 * @Date: 2025-04-10 12:24:11
 * @LastEditTime: 2025-06-05 10:02:09
-->
<template>
  <div class="processPage-box">
    <van-list v-model="listLoading" :finished="finished" @load="onLoad" style="background-color: #f0f2f1">
      <div class="tabcard" v-for="(item, i) in dataList" :key="i">
        <span class="title">{{item.taskName.length<28?item.taskName:item.taskName.slice(0,27)+"..."}}</span>
        <div class="title-right">
          <span style="color: #e9b729;">截止时间: {{item.priceDate}} {{item.lateReportTime}}</span>
        </div>
        <div class="tabcard-content" @click="toList(item)">
          <!-- 数字比例 -->
          <div class="RatioNumber" v-if="item.ifJCDApp == 0">监测点：<span style="color: red;" v-if="item.alreadInputNum">{{item.alreadInputNum}}</span><span v-else>0</span>/{{item.totalInputNum}}</div>
          <div class="dailr" :class="[item.dlrflag == 1?isBlue: item.dlrflag == 2?isGreen:isGrey]">
            <span v-if="item.dlrflag == 2">已录入</span>
            <span v-else>待录入</span>
          </div>
          <div class="kuang">
            <div class="up"></div>
            <div class="dot"></div>
            <div class="down"></div>
          </div>
          <div class="daishangbao" :class="[item.dsbflag == 1?isBlue: item.dsbflag == 2?isGreen:isGrey]">
            <span v-if="item.dsbflag == 2">已上报</span>
            <span v-else>待上报</span>
          </div>
          <div class="daishangbao-box1"></div>
          <div class="daishangbao-box2"></div>
          <div class="yituihui" :class="[item.ythflag == 1?isBlue: item.ythflag == 2?isGreen:isGrey]">
            已退回
          </div>
          <div class="yituihui-box1"></div>
          <div class="yituihui-box2"></div>
          <div  class="shishenhe" :class="[item.shispflag == 1?isBlue: item.shispflag == 2?isGreen:isGrey]">
            地州市<br>审核
          </div>
          <div class="shishenhe-box1"></div>
          <div class="shishenhe-box2"></div>
          <div class="shengshenhe" v-if="item.is_city_release_task !== '1'" :class="[item.shengspflag == 1?isBlue: item.shengspflag == 2?isGreen:isGrey]">
            自治区<br>审核
          </div>
          <div class="shengshenhe-box1"></div>
          <div class="shengshenhe-box2"></div>
          <div  :class="item.is_city_release_task !== '1'?'jiantou1':'jiantou11'"></div>
          <div  :class="item.is_city_release_task !== '1'?'jiantou2':'jiantou22'"></div>
        </div>
        <div class="title-left">
          <span style="color: #4494f3;">{{item.exeno}}</span>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
export default {
  name: 'processPage',
  props: {
    dataList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  components: {},
  computed: {},
  watch: {
    dataList(newVal) {
      console.log('newVal', newVal);
    }
  },
  data() {
    return {
      finished: false, //数据是否加载完
      listLoading: false, //是否显示底部加载中状态
      isBlue: 'blue2', //蓝色
      isGreen: 'green', //绿色
      isGrey: 'grey' //灰色
    };
  },

  created() {},
  mounted() {},
  methods: {
    onLoad() {
      setTimeout(() => {
        this.listLoading = false;
        this.finished = true;
      }, 1000);
    },
    toList(item, index) {
      this.$emit('handCilck', item, index)
      
    }
  },
  beforeDestroy() {},
  destroyed() {}
};
</script>
<style scoped lang="scss">
.processPage-box {
  width: 100%;
  height: 100%;
  .tabcard {
    //卡片
    // width: 100%;
    margin-top: 0.36rem;
    padding-left: px2rem(35);
    padding-right: px2rem(45);
    height: px2rem(370);
    background-color: #fff;
    position: relative;

    .title {
        font-size: px2rem(36);
        font-weight: bold;
        color: #4494f3;
        position: absolute;
        top: px2rem(40);
    }
    .stationTitle {
        font-size: px2rem(36);
        position: absolute;
    }
    .title-right {
        display: inline-block;
        font-size: px2rem(36);
        position: absolute;
        right: px2rem(80);
        bottom: px2rem(20);
    }
    .title-left {
        display: inline-block;
        font-size: px2rem(36);
        position: absolute;
        left: px2rem(60);
        bottom: px2rem(20);
    }
    .tabcard-content {
      position: relative;
      padding-top: 0.75rem;
      height: calc(100% - 0.75rem);
      .RatioNumber {//卡片比例数值
          position: absolute;
          top: 1rem;
          left: 6.8rem;
          font-size: px2rem(30);
      }
      .dailr {
          position: absolute;
          top: 1.6rem;
          left: 0.6rem;
          width: px2rem(180);
          height: px2rem(56);
          line-height: px2rem(56);
          border-radius: px2rem(56);
          color: #fff;
          text-align: center;
          font-size: 0.37rem;
      }

      .kuang {
          display: inline-block;
          position: absolute;
          top: 1.25rem;
          left: 2.35rem;
          width: 0.3rem;
          height: 1.1rem;
          .up {
              margin-left: 0.06rem;
              width: 0.3rem;
              height: 0.5rem;
              border: px2rem(1) solid #4494f3;
              border-color: #4494f3 transparent transparent #4494f3;
          }

          .dot {
              width: px2rem(10);
              height: px2rem(10);
              border: px2rem(1) solid #4494f3;
              border-radius: 90%;
          }

          .down {
              margin-left: 0.06rem;
              width: 0.3rem;
              height: 0.5rem;
              border: px2rem(1) solid #4494f3;
              border-color: transparent transparent #4494f3 #4494f3;
          }
      }

      .daishangbao {
          position: absolute;
          top: 1rem;
          left: 2.8rem;
          width: px2rem(180);
          height: px2rem(56);
          line-height: px2rem(56);
          color: #fff;
          font-size: 0.37rem;
          text-align: center;
      }

      .daishangbao-box1 {
          position: absolute;
          width: 0;
          height: 0;
          top: 1rem;
          left: 2.8rem;
          border-width: px2rem(28);
          border-style: solid;
          border-color: transparent transparent transparent #ffffff;
      }

      .daishangbao-box2 {
          position: absolute;
          width: 0;
          height: 0;
          top: 0.975rem;
          left: 4.2rem;
          border-width: 0.285rem;
          border-style: solid;
          border-color: #fff #fff #fff transparent;
      }

      .yituihui {
          position: absolute;
          top: 2.2rem;
          left: 2.8rem;
          width: px2rem(180);
          height: px2rem(56);
          line-height: px2rem(56);
          color: #fff;
          font-size: 0.37rem;
          text-align: center;
      }

      .yituihui-box1 {
          position: absolute;
          width: 0;
          height: 0;
          top: 2.181rem;
          left: 2.54rem;
          border-width: 0.279rem;
          border-style: solid;
          border-color: #fff transparent #fff transparent;
      }

      .yituihui-box2 {
          position: absolute;
          width: 0;
          height: 0;
          top: 2.2rem;
          left: 3.975rem;
          border-width: px2rem(28);
          border-style: solid;
          border-color: transparent #fff transparent transparent;
      }
      .shishenhe {
          position: absolute;
          top: 1.48rem;
          left: 4.5rem;
          width: 2rem;
          height: 0.82rem;
          line-height: 0.43rem;
          color: #fff;
          font-size: 0.37rem;
          text-align: center
      }

      .shishenhe-box1 {
          position: absolute;
          width: 0;
          height: 0;
          top: 1.48rem;
          left: 4.5rem;
          border-width: 0.41rem;
          border-style: solid;
          border-color: transparent transparent transparent #fff;
      }

      .shishenhe-box2 {
          position: absolute;
          width: 0;
          height: 0;
          top: 1.48rem;
          left: 6.1rem;
          border-width: 0.42rem;
          border-style: solid;
          border-color: #fff #fff #fff transparent;
      }

      .shengshenhe {
          position: absolute;
          top: 1.48rem;
          left: 6.5rem;
          width: 2rem;
          height: 0.82rem;
          line-height: 0.43rem;
          color: #fff;
          font-size: 0.37rem;
          text-align: center;
      }

      .shengshenhe-box1 {
          position: absolute;
          width: 0;
          height: 0;
          top: 1.48rem;
          left: 6.47rem;
          border-width: 0.42rem;
          border-style: solid;
          border-color: transparent transparent transparent #fff;
      }

      .shengshenhe-box2 {
          position: absolute;
          width: 0;
          height: 0;
          top: 1.48rem;
          left: 8.1rem;
          border-width: 0.42rem;
          border-style: solid;
          border-color: #fff #fff #fff transparent;
      }

      .blue2 {
          background-color: #4494f3;
          color: #fff;
      }
      .green {
          background-color: #06c160;
          color: #fff;
      }
      .grey {
          background-color: #e4ecf6;
          color: #4e4f50;
      }

      .jiantou1 {
          position: absolute;
          top: 1.65rem;
          left: 8.6rem;
          width: 0;
          height: 0;
          border-width: 0.26rem;
          border-style: solid;
          border-color: transparent transparent transparent #3e3e3e;
          // background: url("../../assets/jiantou.png");
          // background-size: 100% 100%;
      }

      .jiantou2 {
          position: absolute;
          top: 1.68rem;
          left: 8.55rem;
          width: 0;
          height: 0;
          border-width: 0.21rem;
          border-style: solid;
          border-color: transparent transparent transparent #fff;
          // background: url("../../assets/jiantou.png");
          // background-size: 100% 100%;
      }
    }
      // 底部信息
    .bottom-msg {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .msg-item {
        font-size: px2rem(35);
        color: #555;
        .msg-item-text {
          color: #000;
        }
      }
    }
  }
}
</style>
